import { DeleteOutlineIcon } from '@carboncopyco/icons';
import type { ConfirmAlertProps } from '@carboncopyco/ui';
import { ConfirmAlert, TextBase, notify } from '@carboncopyco/ui';
import { useBoolean } from 'ahooks';
import type React from 'react';

export interface RuleDeletionAlertProps
  extends Pick<ConfirmAlertProps, 'onClose'> {
  open: ConfirmAlertProps['show'];
  rulePreview: React.ReactNode;
  onConfirm: () => Promise<unknown>;
  title?: string;
  onErrorMessage?: string;
  children?: React.ReactNode;
  textLabel?: string;
}

export const RuleDeletionAlert = ({
  open,
  onClose,
  onConfirm,
  rulePreview,
  title = 'Delete rule',
  onErrorMessage = 'Failed deleting rule',
  children,
  textLabel = 'Are you sure you want to delete:',
}: RuleDeletionAlertProps) => {
  const [deleting, setDeleting] = useBoolean();
  const onDelete = async () => {
    setDeleting.setTrue();
    try {
      await onConfirm?.();
    } catch (_e) {
      notify.error(onErrorMessage);
    }
    setDeleting.setFalse();
  };

  return (
    <ConfirmAlert
      show={open}
      title={title}
      danger
      yesLabel="Delete"
      yesIcon={<DeleteOutlineIcon />}
      onConfirm={onDelete}
      onClose={onClose}
      disabled={deleting}
    >
      <div className="flex flex-col gap-2.5 w-ds-normal-modal">
        <TextBase label={textLabel} />
        <div className="overflow-hidden overflow-ellipsis whitespace-nowrap">
          {rulePreview}
        </div>
      </div>
      {children && <div className="mt-6">{children}</div>}
    </ConfirmAlert>
  );
};
